import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  appBarStyle: {
    background: "inherit",
    color: "#171b5e",
    boxShadow: "none",
    padding: "0.2rem 2rem",
    "@media (max-width: 768px)": {
      padding: "0.5rem 5px",
    },
  },
  headerTitle: {
    variant: "h6",
    marginLeft: "25px",
    fontSize: "20px",
    fontWeight: 500,
    "@media (max-width: 768px)": {
      fontSize: "14px",
      fontWeight: 400,
      marginLeft: "30px",
      marginTop: "10px",
    },
  },
  userIcon: {
    position: "relative",
    width: "50px",
    height: "50px",
    background: "#043d902e 0% 0% no-repeat padding-box",
    color: "#66697a",
    border: "1px solid #707070",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "6px 6px 10px #0000001a",
    "@media (max-width: 768px)": {
      width: "40px",
      height: "40px",
    },
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    "@media (max-width: 768px)": {
      gap: "10px",
    },
  },
});

export default Style;
